export const MULTIPART_HEADER = {
  headers: {
    'Content-Type': 'multipart/form-data',
  },
};
export const ARRAY_BUFFER_RESPONSE = {
  responseType: 'arraybuffer',
};
